<div class="mobile-desktop-page">
  <div class="card">
    <img
      class="logo"
      [src]="'assets/scanafy_company_logo_croped.png'"
      alt="Scanafy"
    />

    <ng-container *ngIf="isPlatformAdmin; else standardDesktopHandoff">
      <h1 class="title">{{ 'MOBILE_DESKTOP.ADMIN.TITLE' | translate }}</h1>
      <p class="subtitle">{{ 'MOBILE_DESKTOP.ADMIN.DESCRIPTION' | translate }}</p>
      <p class="subtitle">{{ 'MOBILE_DESKTOP.ADMIN.SIGN_IN_INSTRUCTION' | translate }}</p>
    </ng-container>

    <ng-template #standardDesktopHandoff>
      <h1 class="title">{{ 'MOBILE_DESKTOP.TITLE' | translate }}</h1>
      <p class="subtitle">{{ 'MOBILE_DESKTOP.SUBTITLE' | translate }}</p>

      <div class="actions">
        <button nz-button nzType="primary" (click)="emailLink()" [disabled]="isEmailLoading">
          {{ isEmailLoading ? ('MOBILE_DESKTOP.SENDING' | translate) : ('MOBILE_DESKTOP.CTA_EMAIL' | translate) }}
        </button>

        <button nz-button nzType="default" (click)="copyLink()" [disabled]="isCopyLoading">
          {{ isCopyLoading ? ('MOBILE_DESKTOP.GENERATING' | translate) : ('MOBILE_DESKTOP.CTA_COPY' | translate) }}
        </button>
      </div>

      <div class="url" *ngIf="desktopLink">
        <span class="value">{{ desktopLink }}</span>
      </div>
    </ng-template>

    <button nz-button nzType="default" nzDanger class="logout" (click)="logout()">
      {{ 'MOBILE_DESKTOP.LOGOUT' | translate }}
    </button>
  </div>
</div>
